@if (tidField) {
  <div class="term-id" pub-field-render [field]="tidField"></div>
}
<div [class]="termClass" [lang]="term?.languageCode" pub-field-render
[field]="termNameField"></div>
@if (regionField) {
  <div class="lang-var">
    <div pub-field-render [field]="regionField"></div>
  </div>
}
@if (scriptField) {
  <div class="lang-var">
    <div pub-field-render [field]="scriptField"></div>
  </div>
}
@if (termFields?.length) {
  <div class="fset tl">
    @for (field of termFields; track field.oid) {
      <div pub-field-render [field]="field"
      (conceptSelected)="selectConcept($event)"></div>
    }
  </div>
}
